import {createContext} from "react";
import {AppContextProps} from "~/context/AppContext.props";

export const AppContext = createContext<AppContextProps>({popupContainer: undefined});
